// extracted by mini-css-extract-plugin
export default {"pathway":"HztMw89yAyoYfMAX78hB","img":"Of177_en_oC2deE65x1r","pathwayBody":"jpJxZMGaymyFlTjI0zBS","pathwayLink":"jCkBU6TjfRDpavZk0Ing"};